import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.html',
})
export class AppComponent {}



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/app.component.ts